/* bm_peakExplorer_addonGate.js - links product add-ons to map tools */
(() => {
  'use strict';

  const BM_ADDON_KEYS = Object.freeze({
    gpx: 'gpx',
    snow: 'snowModeling'
  });
  const BM_ADDON_EVENT = 'bm:peakExplorer:addon-state-change';

  function bm_peakExplorer_productId(root) {
    const productElement = root?.querySelector?.('script[type="application/json"][data-product]');
    try {
      const product = JSON.parse(productElement?.textContent || '{}');
      return product?.id == null ? '' : String(product.id);
    } catch {
      return '';
    }
  }

  function bm_peakExplorer_findAddonScope(root) {
    const localScope = root?.closest?.('.bm_customMountain_root');
    if (localScope?.querySelector('[data-bm-product-options-addons]')) return localScope;

    const productId = bm_peakExplorer_productId(root);
    if (productId) {
      const matchingScope = Array.from(
        document.querySelectorAll('.bm_customMountain_root[data-product-id]')
      ).find(candidate => (
        candidate.dataset.productId === productId &&
        candidate.querySelector('[data-bm-product-options-addons]')
      ));
      if (matchingScope) return matchingScope;
    }

    const addonScopes = Array.from(document.querySelectorAll('[data-bm-product-options-addons]'));
    return addonScopes.length === 1 ? addonScopes[0] : null;
  }

  function bm_peakExplorer_readAddonState(root) {
    const scope = bm_peakExplorer_findAddonScope(root);
    if (!scope) {
      return Object.freeze({ available: false, gpxBooked: false, snowBooked: false });
    }

    const gpxInput = scope.querySelector(
      `[data-bm-product-options-property="${BM_ADDON_KEYS.gpx}"]`
    );
    const snowInput = scope.querySelector(
      `[data-bm-product-options-property="${BM_ADDON_KEYS.snow}"]`
    );

    return Object.freeze({
      available: Boolean(gpxInput || snowInput),
      gpxBooked: Boolean(gpxInput?.checked && !gpxInput.disabled),
      snowBooked: Boolean(snowInput?.checked && !snowInput.disabled)
    });
  }

  function bm_peakExplorer_attachAddonGate({ root, onChange }) {
    if (!root || typeof onChange !== 'function') return null;

    const scope = bm_peakExplorer_findAddonScope(root);
    if (!scope) return null;

    const panels = {
      gpx: root.querySelector('[data-role="gpx-addon-panel"]'),
      snow: root.querySelector('[data-role="snow-addon-panel"]')
    };
    let previousState = null;

    const setPanelState = (panel, isBooked) => {
      if (!panel) return;
      const content = panel.querySelector('.bm-addon-panel-content');
      const status = panel.querySelector('[data-role="addon-status"]');
      panel.dataset.bmAddonBooked = String(isBooked);
      panel.setAttribute('aria-disabled', String(!isBooked));
      if (content) content.inert = !isBooked;
      if (status) status.textContent = isBooked ? 'Gebucht' : 'Zusatzleistung wählen';
      if (!isBooked) panel.open = false;
    };

    const sync = () => {
      const state = bm_peakExplorer_readAddonState(root);
      if (!state.available) return;

      const gpxWasBooked = previousState?.gpxBooked === true;
      const snowWasBooked = previousState?.snowBooked === true;
      setPanelState(panels.gpx, state.gpxBooked);
      setPanelState(panels.snow, state.snowBooked);
      if (state.gpxBooked && !gpxWasBooked && panels.gpx) panels.gpx.open = true;
      if (state.snowBooked && !snowWasBooked && panels.snow) panels.snow.open = true;

      previousState = state;
      root.dataset.bmGpxAddonBooked = String(state.gpxBooked);
      root.dataset.bmSnowAddonBooked = String(state.snowBooked);
      onChange(state);
      root.dispatchEvent(new CustomEvent(BM_ADDON_EVENT, { bubbles: true, detail: state }));
    };

    const preventUnavailableToggle = (event) => {
      const panel = event.currentTarget?.closest?.('.bm-addon-panel');
      if (panel?.dataset.bmAddonBooked !== 'true') event.preventDefault();
    };
    const handleScopeChange = (event) => {
      if (event.target?.matches?.('[data-bm-product-options-property]')) sync();
    };

    Object.values(panels).forEach(panel => {
      panel?.querySelector('summary')?.addEventListener('click', preventUnavailableToggle);
    });
    scope.addEventListener('change', handleScopeChange);
    sync();

    return () => {
      scope.removeEventListener('change', handleScopeChange);
      Object.values(panels).forEach(panel => {
        panel?.querySelector('summary')?.removeEventListener('click', preventUnavailableToggle);
      });
      delete root.dataset.bmGpxAddonBooked;
      delete root.dataset.bmSnowAddonBooked;
    };
  }

  window.BM = window.BM || {};
  window.BM.bm_peakExplorer_readAddonState = bm_peakExplorer_readAddonState;
  window.BM.bm_peakExplorer_attachAddonGate = bm_peakExplorer_attachAddonGate;
})();
